import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { PrimaryButton } from '../Button';
import { useScratchpadContext } from './ScratchpadContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 64px 24px 24px;
`;

const Description = styled.p`
  margin: 0;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;

const EmptyScratchpads = () => {
  const { handleCreateNew } = useScratchpadContext();

  return (
    <Container>
      <Description>
        This is your personal scratchpad - only you can see it! Use it to gather
        ideas, add notes, images, and reports, or organize your thoughts as you
        explore.
      </Description>
      <PrimaryButton onClick={() => handleCreateNew()}>
        Create Scratchpad
      </PrimaryButton>
    </Container>
  );
};

export default EmptyScratchpads;
